import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  EmailShareButton,
  PinterestShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  LinkedinIcon,
  TelegramIcon,
  EmailIcon,
  PinterestIcon,
} from "react-share";
import Textarea from "../form/Textarea";
import { useState } from "react";
import { classNames } from "../../helpers/classNames";

export default function SocialShare({ data = {}, buttonClass, shareUrl }) {
  const [comment, setComment] = useState("");

  return (
    <>
      <Popover>
        <PopoverButton
          className={classNames(
            "font-CanelaDeck relative overflow-hidden flex justify-center items-center gap-2 bg-chestnut-rose text-white py-0 transition-all duration-200 hover:bg-blue-zodiac !h-12 xls:!h-14 !rounded-full !px-6 xls:!px-12 text-sm xls:!text-xl",
            buttonClass
          )}
        >
          <i className="fa-solid fa-share-from-square text-lg sm:text-2xl"></i>
          Share
          <div className="flex gap-1">
            <i className="fa-brands fa-square-facebook"></i>
            <i className="fa-brands fa-square-x-twitter"></i>
            <i className="fa-brands fa-square-whatsapp"></i>
          </div>
        </PopoverButton>
        <PopoverPanel
          transition
          anchor="bottom"
          className="divide-y divide-white/5 rounded-xl bg-white text-sm/6 transition duration-200 ease-in-out [--anchor-gap:var(--spacing-5)] data-[closed]:-translate-y-1 data-[closed]:opacity-0 p-4 shadow-lg mt-2 w-72"
        >
          <Textarea
            inputValue={comment}
            onChange={(e) => setComment(e.target.value)}
            inputPlaceholder="Write your comment to share..."
            inputClasses="border p-2 w-full rounded mb-4"
          />
          <div className="flex flex-wrap gap-3 items-center justify-center">
            <FacebookShareButton
              url={shareUrl}
              quote={comment}
              className="hover:opacity-60 transition-all duration-150"
            >
              <FacebookIcon size={35} square />
            </FacebookShareButton>

            <TwitterShareButton
              url={shareUrl}
              title={comment}
              className="hover:opacity-60 transition-all duration-150"
            >
              <TwitterIcon size={35} square />
            </TwitterShareButton>

            <WhatsappShareButton
              url={shareUrl}
              title={comment + "\n"}
              className="hover:opacity-60 transition-all duration-150"
            >
              <WhatsappIcon size={35} square />
            </WhatsappShareButton>

            <LinkedinShareButton
              url={shareUrl}
              className="hover:opacity-60 transition-all duration-150"
            >
              <LinkedinIcon size={35} square />
            </LinkedinShareButton>

            <TelegramShareButton
              url={shareUrl}
              title={comment}
              className="hover:opacity-60 transition-all duration-150"
            >
              <TelegramIcon size={35} square />
            </TelegramShareButton>

            <EmailShareButton
              url={shareUrl}
              subject={"Project Link"}
              body={comment}
              className="hover:opacity-60 transition-all duration-150"
            >
              <EmailIcon size={35} square />
            </EmailShareButton>

            <PinterestShareButton
              url={shareUrl}
              media={
                "https://api.vpeters.iosx.in/storage/siteSetting/1743417005875dda5cb3afff45cf652deb5ed.jpeg"
              }
              description={comment}
            >
              <PinterestIcon size={35} square />
            </PinterestShareButton>
          </div>
        </PopoverPanel>
      </Popover>
    </>
  );
}
